export enum LayerName {
  COLOR = 'color',
	GRID = 'grid',
	PATTERN = 'pattern',
	COUNTRIES = 'countries',
	BALKAN = 'balkan',
  NESTED = 'nested',
  GOOGLE = 'google',
}
